import React from "react";
import { Link } from "react-router-dom";

export default function BtnRight({ to, label, icon, className, onClick }) {
  // detect if it's an external link or a static asset (like .pdf)
  const isExternal =
    to?.startsWith("http") ||
    to?.endsWith(".pdf") ||
    to?.startsWith("/caseStudy/");

  if (isExternal) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={onClick}
      >
        {label} {icon}
      </a>
    );
  }

  return (
    <Link className={className} to={to} onClick={onClick}>
      {label} {icon}
    </Link>
  );
}
